import { useState, useCallback } from 'react';
import { getOnboardingFunnelStatus } from 'src/components/enterprise/features/HomePage/components/OnboardingFunnelWrapper/api/getOnboardingFunnelStatusApi';
import { OnboardingFunnelDetails } from 'src/components/enterprise/features/HomePage/types/OnboardingFunnel';

export interface UseGetFunnelStatusReturnType {
  isLoading: boolean;
  hasError: boolean;
  funnelDetails: OnboardingFunnelDetails | null;
  fetchFunnelStatus: () => Promise<void>;
}

export const useGetFunnelStatus = (
  corpId: string
): UseGetFunnelStatusReturnType => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [funnelDetails, setFunnelDetails] =
    useState<OnboardingFunnelDetails | null>(null);

  const fetchFunnelStatus = useCallback(async (): Promise<void> => {
    try {
      setIsLoading(true);
      setHasError(false);

      const details = await getOnboardingFunnelStatus(corpId);
      setFunnelDetails(details);
    } catch (error) {
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  }, [corpId]);

  return { isLoading, hasError, funnelDetails, fetchFunnelStatus };
};
